import { mean } from './format';

// Water from other-trackers' daily water summary. Each day carries its own
// plan, so adherence uses that day's plan (targets can change over time). A
// day counts as logged only when its intake is above 0; a missing row or 0 ml
// is "Not logged", never 0.

export const WATER_LOADING = 'Loading water…';
export const WATER_ERROR = 'Water tracking couldn’t be loaded';

const sum = (types, key) => (types || []).reduce((total, t) => total + (Number(t?.[key]) || 0), 0);

/**
 * Summary rows → one entry per day. Intake and plan are the sums over the
 * row's quantity types (ml), as `fetchWaterSummary` reads them.
 * @returns {Array<{ date: string, ml: number, plan: number|null, logged: boolean }>}
 */
export function waterDaysOf(rows) {
  return (rows || [])
    .filter((r) => r?.date)
    .map((r) => {
      const ml = sum(r.quantity_types, 'total_actual_quantity');
      const plan = sum(r.quantity_types, 'total_plan_water_quantity');
      return { date: String(r.date).slice(0, 10), ml, plan: plan > 0 ? plan : null, logged: ml > 0 };
    });
}

/** `waterDays` → `{ [iso]: { ml, plan } }` for logged days only. */
export function waterByDay(waterDays) {
  const out = {};
  (waterDays || []).forEach((r) => {
    if (r.logged) out[r.date] = { ml: r.ml, plan: r.plan };
  });
  return out;
}

/** A day's adherence: intake ÷ its plan, capped at 100%; null without a plan. */
export const dayPct = (d) => (d?.plan ? Math.min(d.ml / d.plan, 1) * 100 : null);

/**
 * Water over a span.
 * - `pct`: mean of each logged day's capped adherence, over days with a plan (the design's `hydPct`).
 * - `hasPlan`: whether any logged day had a plan.
 */
export function waterStats(byDay, isos) {
  const L = isos.filter((iso) => byDay[iso]).map((iso) => byDay[iso]);
  const P = L.filter((d) => d.plan);
  return {
    n: L.length,
    avg: mean(L.map((d) => d.ml)),
    avgPlan: mean(P.map((d) => d.plan)),
    met: P.filter((d) => d.ml >= d.plan).length,
    pct: P.length ? mean(P.map(dayPct)) : null,
    hasPlan: P.length > 0,
  };
}
